
/*
 * Common code between the line adjuster and area adjuster
 */
class LineAreaAdjuster {

  constructor (options) {
    this.lineStroke = options.lineStroke
    this.curve = options.curve
    this.chart = options.chart
    this.previous = options.previous
    this.yScale = options.yScale
    this.xScale = options.xScale

    this.pathGenerator = this._pathGenerator(options.xScale, options.yScale)
  }

  /*
   * Returns if a point is defined.
   * If it has a `_index`, the point is in a stack, which is always defined
   * Otherwise looks at the point's raw value
   */
  defined (d) {
    return Number.isFinite(d._index) || (d && !isNaN(d.raw))
  }

}

export default LineAreaAdjuster
